module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "part01"
    }
  }, [_c('div', {
    staticClass: "partHead",
    attrs: {
      "id": "partHead01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('h2', {
    staticClass: "partNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/005TOC#part_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART I")])])]), _vm._v(" "), _c('div', {
    staticClass: "partEpigraph1",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('p', {
    staticClass: "partEpigraphText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Let us face the fact that the monastic vocation")])]), _vm._v(" "), _c('p', {
    staticClass: "partEpigraphText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("tends to present itself to the modern world")])]), _vm._v(" "), _c('p', {
    staticClass: "partEpigraphText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("as a problem and as a scandal.")])]), _vm._v(" "), _c('p', {
    staticClass: "partEpigraphSource",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("THOMAS MERTON")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b305140","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006-part01.vue
// module id = 72
// module chunks = 0